package com.example.mystybag.core.model

import kotlinx.serialization.Serializable

@Serializable
data class LinkModel(
    var text    : String    = "",
    var link    : String    = ""
)